module.exports = __webpack_public_path__ + "20250721160708/img/by_list.5b86e68f.png";